import ReactPaginate from 'react-paginate';
import { Flex } from '@chakra-ui/react';

export const Pagination = ({
  currPage = 0,
  totalPage = 0,
  handlePageClick = () => {},
}) => {
  return (
    <Flex justifyContent="end" className="pagination">
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        forcePage={currPage}
        onPageChange={handlePageClick}
        previousLabel="<"
        pageCount={totalPage}
      />
    </Flex>
  );
};
